import React from 'react'
import IconNote from "@/assets/images/scheme/icon-note.png";
import OverPack from "rc-scroll-anim/lib/ScrollOverPack";
import QueueAnim from "rc-queue-anim";
import Bg01 from "@/assets/images/scheme/d-bg01.png";
import Bg02 from "@/assets/images/scheme/d-bg02.png";
import Bg03 from "@/assets/images/scheme/d-bg03.png";
import Bg04 from "@/assets/images/scheme/d-bg04.png";
import Bg05 from "@/assets/images/scheme/d-bg05.png";
import Bg06 from "@/assets/images/scheme/d-bg06.png";
import Bg07 from "@/assets/images/scheme/d-bg07.png";
import Bg08 from "@/assets/images/scheme/d-bg08.png";
import Bg09 from "@/assets/images/scheme/d-bg09.png";


const ElectricList = () => {
  return (
    <div className='wrap-bank-list'>
      <div className='wrap-bank-list-header'>
        <div className='wrap-bank-list-header-box home-page'>
          <img className='icon-note' src={IconNote} />
          <div className='wrap-title'>背景与需求分析</div>
        </div>
      </div>
      <div className='wrap-bank-list-summary'>
        <div className='home-page'>
          <>
            <div className='title' style={{marginBottom: '50px'}}>
              企业要求： <br/>
              <span>非数字原生企业的数字化转型现状</span>
            </div>
            <img src={Bg01} alt="" width='1200px' key='img' />
          </>
          <OverPack playScale={0.3}>
            <QueueAnim
              key="text"
              type="bottom"
              leaveReverse
              ease={['easeOutQuad', 'easeInQuad']}
              style={{minHeight: '500px', marginTop: '50px'}}
            >
              <img src={Bg02} alt="" width='1200px' key='img' />
            </QueueAnim>
          </OverPack>
          <OverPack playScale={0.3}>
            <QueueAnim
              key="text"
              type="bottom"
              leaveReverse
              ease={['easeOutQuad', 'easeInQuad']}
              style={{minHeight: '500px'}}
            >
              <div className='title' style={{margin: '101px 0 60px'}} key='title'>
                非数字原生企业的数字化转型阻碍
              </div>
              <img src={Bg03} alt="" width='1200px' key='img' />
            </QueueAnim>
          </OverPack>
          <OverPack playScale={0.3}>
            <QueueAnim
              key="text"
              type="bottom"
              leaveReverse
              ease={['easeOutQuad', 'easeInQuad']}
              style={{minHeight: '500px'}}
            >
              <div className='title' style={{margin: '100px 0 60px'}} key='title'>
                数字化转型本质
              </div>
              <img src={Bg04} alt="" width='1200px' key='img' />
            </QueueAnim>
          </OverPack>
          <OverPack playScale={0.3}>
            <QueueAnim
              key="text"
              type="bottom"
              leaveReverse
              ease={['easeOutQuad', 'easeInQuad']}
              style={{minHeight: '500px'}}
            >
              <div className='title' style={{margin: '100px 0 50px'}}  key='title'>
                <span>解决思路与实施框架</span> <br />
                在线转型4步法
              </div>
              <img src={Bg05} alt="" width='1200px' key='img' />
            </QueueAnim>
          </OverPack>
          <OverPack playScale={0.3}>
            <QueueAnim
              key="text"
              type="bottom"
              leaveReverse
              ease={['easeOutQuad', 'easeInQuad']}
              style={{minHeight: '500px'}}
            >
              <div className='title' style={{margin: '100px 0 50px'}} key='title'>
                <span>围绕第一效率指标建立解决方案</span>
              </div>
              <img src={Bg06} alt="" width='1200px' key='img' />
            </QueueAnim>
          </OverPack>
          <OverPack playScale={0.3}>
            <QueueAnim
              key="text"
              type="bottom"
              leaveReverse
              ease={['easeOutQuad', 'easeInQuad']}
              style={{minHeight: '500px', marginTop: '50px'}}
            >
              <img src={Bg07} alt="" width='1200px' key='img' />
            </QueueAnim>
          </OverPack>
          <OverPack playScale={0.3}>
            <QueueAnim
              key="text"
              type="bottom"
              leaveReverse
              ease={['easeOutQuad', 'easeInQuad']}
              style={{minHeight: '500px'}}
            >
              <img src={Bg08} alt="" width='1200px' key='img' />
            </QueueAnim>
          </OverPack>
          <OverPack playScale={0.3}>
            <QueueAnim
              key="text"
              type="bottom"
              leaveReverse
              ease={['easeOutQuad', 'easeInQuad']}
              style={{minHeight: '500px'}}
            >
              <div className='title' style={{margin: '100px 0 50px'}} key='title'>
                <span>“能力-认知-态度”三位一体的增值服务体系</span>
              </div>
              <img src={Bg09} alt="" width='1200px' key='img' />
            </QueueAnim>
          </OverPack>
        </div>
      </div>
    </div>
  )
}

export default ElectricList